import { isNil } from 'lodash-es';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SafeImage } from '@/components/common/safe-image';
import useConversationStore, { useConversationHandlers } from '@/hooks/conversations/use-conversation-store';
import { contactMessageScheme } from '@/models/messages/message-type';
import cn from '@/utils/merge-class-names';
import type { ContentCommonProps } from './content-common-props';
import { MessageQuote } from './message-quote';

export default function ContentContact({ message }: ContentCommonProps) {
  const { t } = useTranslation();
  const { resetSelectedMessages } = useConversationStore();
  const { handleInteraction: onInteraction } = useConversationHandlers();

  const handleViewContact = () => {
    resetSelectedMessages([message]);
    onInteraction('contact');
  };

  const contactContent = useMemo(() => {
    try {
      const { success, data } = contactMessageScheme.safeParse(JSON.parse(message.Message));

      return success ? data : undefined;
    } catch (e) {
      return undefined;
    }
  }, [message.Message]);

  return (
    <div className='chat-bubble min-w-min group-data-receiver:chat-bubble-plain group-data-sender:chat-bubble-primary'>
      {message.Quote && (
        <MessageQuote
          className='py-1.5 px-2 mb-1 w-full'
          quote={message.Quote}
        />
      )}

      <button
        type='button'
        onClick={handleViewContact}>
        <div
          className={cn(
            'flex min-w-24 flex-col items-center justify-center gap-2 rounded-md p-2 group-data-sender:theme-ryuryu:bg-blue-300 group-data-sender:theme-wangyou:bg-teal-200 group-data-sender:theme-threetwoone:bg-purple-100 group-data-sender:theme-eightk:bg-purple-100 group-data-sender:theme-bonglan:bg-red-300 group-data-sender:theme-kbar:bg-red-300 group-data-sender:text-body bg-base-200 text-body',
          )}>
          <div className='avatar'>
            <div className='w-10 rounded-full'>
              <SafeImage
                src={contactContent?.HeadImg || '/contents/headimg.jpg'}
                className='size-10'
              />
            </div>
          </div>
          <span>{contactContent?.NickName || t('contact.error.damaged')}</span>
        </div>

        {!isNil(contactContent) && (
          <span className={cn('btn btn-link btn-sm text-secondary group-data-sender:text-body')}>
            {t('common.view')}
          </span>
        )}
      </button>
    </div>
  );
}
